import React, { memo } from 'react';
import productParameterConfigs from './config';
import ProductParameterEditor from './ProductParameterEditor';
function ProductFunctionEditor({ create = false }) {
    return React.createElement(ProductParameterEditor, { config: productParameterConfigs.functions, create: create });
}
export default memo(ProductFunctionEditor);
